import React, { FC } from 'react';
import { SVGProps } from '@utils';
import { SvgWrapper } from './SvgWrapper';

export const PlannerBluePlus: FC<SVGProps> = ({ onClick, divClassName }) => (
  <SvgWrapper
    divClassName={divClassName}
    onClick={onClick}
  >
    <svg width="81" height="81" viewBox="0 0 81 81" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_dd_5645_3158)">
        <ellipse cx="40.3276" cy="37.5" rx="32.3276" ry="32.5" fill="#3273E1"/>
        <path d="M72.4552 37.5C72.4552 55.3398 58.0702 69.8 40.3276 69.8C22.585 69.8 8.2 55.3398 8.2 37.5C8.2 19.6602 22.585 5.2 40.3276 5.2C58.0702 5.2 72.4552 19.6602 72.4552 37.5Z" stroke="white" strokeOpacity="0.98" strokeWidth="0.4"/>
        <path d="M39.8302 53C38.8884 53 38.125 52.2366 38.125 51.2948V38.7143H25.6293C24.6826 38.7143 23.915 37.9468 23.915 37C23.915 36.0532 24.6826 35.2857 25.6293 35.2857H38.125V22.7052C38.125 21.7634 38.8884 21 39.8302 21C40.7719 21 41.5354 21.7634 41.5354 22.7052V35.2857H54.031C54.9778 35.2857 55.7453 36.0532 55.7453 37C55.7453 37.9468 54.9778 38.7143 54.031 38.7143H41.5354V51.2948C41.5354 52.2366 40.7719 53 39.8302 53Z" fill="white" fillOpacity="0.95"/>
      </g>
      <defs>
        <filter id="filter0_dd_5645_3158" x="0" y="0" width="80.6553" height="81" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset/>
          <feGaussianBlur stdDeviation="0.5"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"/>
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5645_3158"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="3"/>
          <feGaussianBlur stdDeviation="4"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.16 0"/>
          <feBlend mode="normal" in2="effect1_dropShadow_5645_3158" result="effect2_dropShadow_5645_3158"/>
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_5645_3158" result="shape"/>
        </filter>
      </defs>
    </svg>

  </SvgWrapper>
);
